
      // Simple device-specific code splitting hint
      // Load different logic or priorities if needed
      window.__IS_MOBILE__ = window.innerWidth < 1024;
    